import { render, staticRenderFns } from "./SaveSuccess.vue?vue&type=template&id=8d3616c6&functional=true"
import script from "./SaveSuccess.vue?vue&type=script&lang=js"
export * from "./SaveSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports